module.exports = __webpack_public_path__ + "static/media/Icon awesome-instagram.0dcf4c7e.svg";